import { Card, Skeleton } from "antd";
import React from "react";

export const ProfileActivitySkeleton: React.FC = () => {
    return (
        <div className="skeleton-item">
            <div className="skeleton-item-cover">
            </div>
            <Card bordered={false} loading className="skeleton-item-card">
                <Skeleton.Input style={{ width: "100%", height: "40px" }} active={true} size="large" block={true} />
                <Skeleton.Input
                    style={{ width: '100%', height: '25%!important' }}
                    active={true}
                    size="small"
                    block={false}
                />
            </Card>
        </div>
    );
};
